const EVERY_FOUR_CHARS = /(.{4})(?!$)/g;

export const formatIBAN = (str: string) => {
  return str.replaceAll(' ', '').replace(EVERY_FOUR_CHARS, '$1' + ' ');
};
